import { getMenuListResultModel } from './model/menuModel';
import { ErrorMessageMode } from '/#/axios';
import { request } from '/@/utils/http/axios';

enum Api {
  GetMenuList = '/getMenuList',
}

/**
 * @description: Get user menu based on id
 */

export const getMenuList = ( mode: ErrorMessageMode = 'modal') => {
  return request.get<getMenuListResultModel>(
    { 
      url: Api.GetMenuList 
    },
    {
      errorMessageMode: mode,
    }
  );
};
